import { Img } from 'openimg/react';
import SectionChild from '~/components/SectionChild';
import { FormSearch } from './_index';
import { Route } from './+types/ky-gui';
import {  useLoaderData } from 'react-router';
import Heading2 from '../__components/heading2';
import { Icon, IconName } from '~/components/ui/icon';
import { cn } from '@repo/ui/lib/utils';
import { Button } from '@repo/ui/components/button';
import { useRef } from 'react';
import { serverCallApiCMS } from '~/services/serverCallAPI';
import { IPage } from '~/types/types';
import { buildCanonicalLink, buildMetaFromLoader, buildSeoMeta, getOrigin } from '~/utils/seo';
import { hostName } from '~/utils/format';
import { StructuredDataScript } from '~/components/structured-data-script';
import ContentPage from '../__components/content-page';

export {action} from './__form.server';

 interface BenefitItem {
  key: string;
  title: string;
  description: string;
  icon: IconName;
}

export const SELLER_BENEFITS: BenefitItem[] = [
  {
    key: "privacySecurity",
    title: "Riêng tư & Bảo mật",
    description: "Thông tin cá nhân và tài sản được giữ kín tuyệt đối.",
    icon: "shield-check",
  },
  {
    key: "strategicConsulting",
    title: "Tư vấn chiến lược",
    description: "Giá bán và kênh tiếp cận phù hợp.",
    icon: "strategic-consulting",
  },
  {
    key: "fullSupport",
    title: "Hỗ trợ toàn diện",
    description: "Từ thủ tục pháp lý, ngân hàng đến giao dịch trọn vẹn.",
    icon: "full-support",
  },
  {
    key: "partnerPrivilege",
    title: "Đặc quyền đối tác",
    description:
      "Tham gia chương trình thân thiết, nhận tư vấn đầu tư & xu hướng thị trường.",
    icon: "trending-up",
  },
];

export async function loader({ request }:Route.LoaderArgs) {

  const contentPage = await serverCallApiCMS<IPage>(
    "/api/v1/web/pages/ky-gui"
  ).catch(() => {
    return {
      slug: "",
      description: "",
      content: "",
      seo: {
        title: "",
        meta_description: "",
        focus_keyphrase: "",
        og_image: [],
      },
      structured: null,
      structuredData: null,
    };
  });


  const origin = getOrigin(request);
  const url = new URL(request.url);
  const canonical = origin ? `${origin}${url.pathname}` : url.pathname;

  return {
    seo: {
      canonical,
      ...contentPage.seo,
    },
    structuredData: contentPage.structuredData ?? null,
    contentPage,
  };
}
export const meta = (args: Route.MetaArgs) => {
  return buildMetaFromLoader(
    args,
    {
      hostName,
      buildSeoMeta,
    },
    (ld) => ld
  );
};

function Page() {
  const ref = useRef<any>(null)
  const { structuredData, contentPage } = useLoaderData<typeof loader>();
  return (
    <div>
      <StructuredDataScript data={structuredData} />
      <div className="relative">
        <div className="min-h-[328px] p-0 w-full md:h-[600px]  relative overflow-hidden">
          <Img
            src={"/image/landing_page/Banner_3.png"}
            fit="cover"
            width={5760}
            height={2400}
            className="absolute w-full h-full bg-content"
            params={{
              "black-white": "true",
              blur: "5",
              quality: "100",
            }}
            alt="Kland"
          />
          <div className="absolute top-[100px] left-0 w-full h-full">
            <SectionChild>
              <div className="max-w-[426px]">
                <h1 className="pb-8 text-3xl font-bold md:text-6xl text-primary">
                  Ký gửi an tâm <br /> Tối ưu giá trị
                </h1>
                <p className="text-white md:text-black">
                  Được thẩm định giá chuẩn xác, tư vấn chiến lược riêng và hỗ
                  trợ pháp lý - tài chính trọn gói để bạn bán nhanh, an toàn và
                  hiệu quả.
                </p>
              </div>
            </SectionChild>
          </div>
        </div>
        <div className="absolute w-full md:-translate-y-1/2 top-full lg:block ">
          <div className="relative" ref={ref}>
            <FormSearch />
          </div>
        </div>
      </div>
      <div className="pt-[200px] md:pt-[100px]">
        <SectionChild className="pt-[60px] pb-[100px]">
          <Heading2 className="text-center">
            Bảo mật tuyệt đối – Không lo bị làm phiền
          </Heading2>
          <div className="mt-10">
            <div className="border border-primary rounded-4xl">
              <div className="grid grid-cols-1 py-10 gap-y-7 md:divide-x divide-primary md:grid-cols-4">
                {SELLER_BENEFITS.map((item) => {
                  return (
                    <div
                      className={cn(
                        "flex flex-col items-center gap-5 px-5 text-center "
                      )}
                      key={item.key}
                    >
                      <div className="">
                        <span>
                          <Icon name={item.icon} className="w-20 h-20" />
                        </span>
                      </div>
                      <div className="w-3/4 h-px bg-primary"></div>
                      <div>
                        <h3 className="text-primary">{item.title}</h3>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </SectionChild>
      </div>
      <SectionChild className="pb-[100px]">
        <div className="w-full h-[620px] relative rounded-4xl overflow-hidden">
          <Img
            src={"/image/landing_page/Banner_4.png"}
            width={1200}
            height={620}
            className="absolute object-cover w-full h-full"
          />
          <div className="relative flex flex-wrap items-end justify-between w-full h-full gap-5 p-10">
            <div className="max-w-[563px] text-white">
              <div className="pb-5 text-5xl font-helve">
                Định giá chuẩn xác <br /> Chiến lược thông minh
              </div>
              <p>
                Tận hưởng nhiều lợi ích vượt trội sau khi ký gửi: hỗ trợ pháp
                lý, tài chính, tư vấn đầu tư, cập nhật xu hướng thị trường, tối
                đa hóa lợi nhuận dài hạn.
              </p>
            </div>
            <div className="p-6 bg-white rounded-[20px] max-w-[296px]">
              <Heading2 className="pb-6">Đồng hành đầu tư</Heading2>
              <p>Sinh lời bền vững cùng KLAND</p>
            </div>
          </div>
        </div>
      </SectionChild>
      <div className='pb-[100px]'>
        <ContentPage content={contentPage.content} />
      </div>

      <div className="relative h-[500px] text-center">
        <Img
          src={"/image/landing_page/Banner_5.png"}
          width={1244}
          height={500}
          className="absolute object-cover w-full h-full"
        />
        <div className="relative w-full h-full bg-grad-second">
          <SectionChild className="relative text-center pt-[100px]">
            <Heading2 className="text-white">
              Hãy để KLAND đồng hành cùng bạn <br />
              Bảo mật, an toàn, tối ưu lợi ích!
            </Heading2>
            <div className="mt-10">
              <Button
                variant={"secondary"}
                onClick={() => {
                  ref.current?.scrollIntoView({
                    behavior: "smooth",
                  });
                }}
              >
                Đăng ký gửi ngay
              </Button>
            </div>
          </SectionChild>
        </div>
      </div>
    </div>
  );
}

export default Page
export const handle = {
  dynamicLinks: (props:any) => {
    return buildCanonicalLink(props?.data?.seo?.canonical || "");
  },
};
